import _regeneratorRuntime from 'babel-runtime/regenerator';
import _JSON$stringify from 'babel-runtime/core-js/json/stringify';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';
import _extends from 'babel-runtime/helpers/extends';

import { mapState, mapActions } from 'vuex';
import ProductInfoVerify from '@pt/components/product-info-dialog.vue';
import _ from 'lodash';
import { materialMakeFrom } from '@pt/utils/push.js';
import { PtBusinessType } from '@pt/components/common-push-dialog/config';

export default {
  props: {
    saveTemplateBeforePush: {
      type: Boolean,
      default: true
    }
  },
  components: {
    ProductInfoVerify: ProductInfoVerify
  },

  computed: _extends({}, mapState({
    id: function id(state) {
      return state.creative.template.id;
    },
    promotedType: function promotedType(state) {
      return _.get(state, 'creative.template.templateConfig.promoted_type');
    },
    isCommonTemplateCustom: function isCommonTemplateCustom(state) {
      return state.creative.template.isCommonTemplateCustom;
    },
    isCreativeTemplateCustom: function isCreativeTemplateCustom(state) {
      return state.creative.template.isCreativeTemplateCustom;
    },
    page: function page(state) {
      return state.creative.template.page;
    },
    templateConfig: function templateConfig(state) {
      return state.creative.template.templateConfig || {};
    }
  }), {
    buttonAttrs: function buttonAttrs() {
      return {
        text: this.$t('common.push.text'),
        type: 'primary',
        size: 'small'
      };
    }
  }),

  methods: _extends({}, mapActions({
    saveTemplate: 'creative/template/saveTemplate'
  }), {
    handleProductUpdate: function handleProductUpdate() {},
    push: function push() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var routeData;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!_this.saveTemplateBeforePush) {
                  _context.next = 3;
                  break;
                }

                _context.next = 3;
                return _this.saveTemplate();

              case 3:
                // let params = {
                //   ids: this.id,
                //   type: 'custom', // 在线制作版本
                //   from: materialMakeFrom.dmaker, // 在线制作
                // }
                // 通用模板制作参数
                routeData = null;

                if (_this.isCommonTemplateCustom) {
                  routeData = _this.$router.resolve({
                    name: 'pl-viewer',
                    query: {
                      type: PtBusinessType.Normal,
                      id: _this.id,
                      from: materialMakeFrom.gmaker,
                      rowData: _JSON$stringify({
                        id: _this.id,
                        pushPermissions: true,
                        name: _this.templateConfig.name,
                        project_type: 'normal'
                      })
                    }
                  });
                  window.open(routeData.href, '_blank');
                } else {
                  // 定制可玩普通制作
                  routeData = _this.$router.resolve({
                    name: 'pl-viewer',
                    query: {
                      type: PtBusinessType.CustomNormal,
                      id: _this.id,
                      from: materialMakeFrom.dmaker,
                      rowData: _JSON$stringify({
                        id: _this.id,
                        pushPermissions: true,
                        isPtVersion: true
                      })
                    }
                  });
                  window.open(routeData.href, '_blank');
                }
                // this.$store.dispatch('creative/pusher/showPushDialog', params)

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },

    // 供外部调用
    emitProductInfoVerify: function emitProductInfoVerify() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!_this2.$refs.productInfoVerifyRef) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt('return', _this2.$refs.productInfoVerifyRef.handleClick());

              case 2:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    }
  })
};